export default "__VITE_ASSET__7773ba1a__"